import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const EnergeticsDefaultProps = {
  ...ClassNameDefaultProps,
  energetics: {},
};

export const EnergeticsPropTypes = {
  ...ClassNamePropTypes,
  energetics: PropTypes.shape({
    energy_classes: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    links: PropTypes.arrayOf(PropTypes.string),
  }),
};
